module.exports = __webpack_public_path__ + "assets/arrow.49b0aa0f.svg";